var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sheetLogs",staticStyle:{"padding":"0px"}},[(_vm.currentIframe)?_c('iframe',{staticClass:"sheetLogs-content",attrs:{"src":_vm.currentUrl,"frameborder":"0","allowtransparency":"true","title":_vm.currentIframe.name}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-5990d5a4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/menu/sheet/attach/sheetIframe.vue
// module id = null
// module chunks = 